import type { Margin } from "recharts/types/util/types"

export const ZERO_MARGIN: Margin = {
	left: 0,
	right: 0,
	top: 0,
	bottom: 0,
}
